<template>
  <div class="modeDisplay">
    <div class="collar-wrapper">
      <component class="editing-component" :is="editingCollar"/>
      <div class="collar-sub-image-wrap">
        <img class="collar-sub-image"
             :class="editingCollar" :src="require(`@/assets/images/${editingCollar}.png`)">
      </div>
    </div>
      <ColorPicker
        :colors="colorsCategories.jacketBodyColors"
        @onSelectColor="onSelectColor"
      />
      <div class="color-label__wrap">
        <div class="color-label">Inside Color:</div>
        <b>{{ insideCollarColor.title }}</b>
      </div>
      <div class="modeDisplayBtn">
        <b-button variant="success" @click="onFinish">Finish</b-button>
      </div>
  </div>
</template>

<script>
import classic from '@/components/jacket/collars/Classic.vue';
import hoodie from '@/components/jacket/collars/Hoodie.vue';
import zipperHood from '@/components/jacket/collars/ZipperHood.vue';
import ColorPicker from '@/components/common/ColorPicker.vue';

export default {
  name: 'CollarModeDisplay',
  components: {
    classic,
    hoodie,
    zipperHood,
    ColorPicker
  },
  props: {
    editingCollar: String,
    collarEditMode: Boolean
  },
  computed: {
    insideCollarColor () {
      return this.$store.getters['design/getInsideCollarColor'];
    },
    colorsCategories () {
      return this.$store.getters['elements/getColorsCategories'];
    },
  },
  methods: {
    onFinish () {
      this.$emit('collarEditModeOff');
    },

    onSelectColor (color) {
      this.$store.commit('design/setInsideCollarColor', { color });
    }
  },
};

</script>

<style scoped>
.modeDisplay {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  margin-left: 10px;
  padding: 0 10px 10px 10px;
}

.color-label__wrap {
  margin-top: 10px;
  margin-bottom: 10px;
}

.editing-component {
  position: relative;
  z-index: 10;
}

.modeDisplayBtn {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.collar-wrapper {
  position: relative;
  margin-bottom: 10px;
}

.collar-sub-image-wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.collar-sub-image {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
}

</style>
